/**
 * The image viewer's verbs, published by the imaging module while Velora's
 * viewer is mounted and read by the `imaging.viewer` slot host
 * (requests-dentrix I-10). Owner: WP0-SHELL; the imaging module publishes.
 */
import { useEffect, useSyncExternalStore } from 'react';
import type { ImagingViewerApi } from './types.js';

let current: ImagingViewerApi | null = null;
const listeners = new Set<() => void>();

function subscribe(l: () => void): () => void {
  listeners.add(l);
  return () => {
    listeners.delete(l);
  };
}

export function publishImagingViewer(api: ImagingViewerApi | null): void {
  current = api;
  for (const l of listeners) l();
}

/** Publishes `api` while the caller is mounted (pass a new object when its state changes). */
export function usePublishImagingViewer(api: ImagingViewerApi | null): void {
  useEffect(() => {
    publishImagingViewer(api);
    return () => {
      if (current === api) publishImagingViewer(null);
    };
  }, [api]);
}

export function useImagingViewerApi(): ImagingViewerApi | null {
  return useSyncExternalStore(
    subscribe,
    () => current,
    () => current,
  );
}
